module.exports = __webpack_public_path__ + "static/img/member_list_2.9b8fd308.png";